<template>
    <div class="relative" :style="{ 'z-index': isFocused || searchList?.length > 0 ? 1000 : 0 }" @focusin="isFocused = true" @focusout="isFocused = false">
        <m-search-field
            :value="value"
            :key="reRenderSearchFld"
			:placeholder="placeholder"
            :inputClass="inputClass"
			:class="[searchWrapperClass, 'z-30 relative']"
			@input="(text) => $emit('input', text)"
			>
		</m-search-field>

        <div @click="() =>( $emit('close'), reRenderSearchFld = Math.random())" v-if="searchList?.length > 0" class="fixed  top-0 left-0 w-full h-full  rounded-lg border-[1px] border-gray-1 z-10"></div>

        <div class="absolute top-full left-0 bg-white shadow-md z-30 w-full">
            <button 
                class="py-2 px-3 block w-full text-left"
                v-for="(item, i) in searchList" :key="i" 
                @click="() => ($emit('change', item), $emit('input', ''), reRenderSearchFld = Math.random())">{{ item.label }}</button>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';

/* ========== STATES ====== */
const reRenderSearchFld = ref(Math.random());
const isFocused = ref(false);

/* ======= PROPS ========= */
defineProps({
    placeholder: { type: String, default: () => 'Search...' },
    value: { type: String, default: () => '' },
    inputClass: { type: String, default: () => '' },
    searchList : { type: Array, default: () => [] },
    searchWrapperClass : { type: String, default: () => '' }
})
</script>